import React from 'react';

interface CursorSignatureProps {
  data: string;
  type: 'signature' | 'initials' | null;
  isActive: boolean;
  position: { x: number; y: number };
}

export const CursorSignature: React.FC<CursorSignatureProps> = ({ 
  data, 
  type,
  isActive,
  position,
}) => {
  if (!isActive || !data) return null;

  const isInitials = type === 'initials';

  return (
    <div
      className="fixed z-50 transform -translate-x-1/2 -translate-y-1/2"
      style={{
        left: position.x,
        top: position.y,
        pointerEvents: 'none',
      }}
    >
      <div className="bg-background/90 backdrop-blur-sm border-2 border-primary rounded-lg p-2 shadow-lg opacity-80">
        <img
          src={data}
          alt={`${isInitials ? 'Initials' : 'Signature'} preview`}
          className={`object-contain select-none ${isInitials ? 'h-6 max-w-16' : 'h-8 max-w-32'}`}
          draggable={false}
          onDragStart={(e) => e.preventDefault()}
        />
      </div>
    </div>
  );
};